module.exports = __webpack_public_path__ + "img/m2.202543a6.jpg";